import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { routes } from 'utils/routes';
import { isInIframe } from 'integrations/utils/isInIframe';
import { sessionStore } from 'store/Session';
import { useWinMessage } from 'store/GameMessage/useCases/useWinMessage';
import { GameMessage } from './GameMessage';

export const GameMessageLogic = () => {
    useWinMessage();
    const location = useLocation();

    const dynamicHeight = isInIframe() && sessionStore.dynamicHeight;

    const isColumnLayout = React.useMemo(() => {
        const gameRoutes = routes.game(':gameId');
        const validRoutes = [
            gameRoutes.current,
            gameRoutes.past,
            gameRoutes.upcoming,
            gameRoutes.standings(),
            gameRoutes.matchInfo(),
        ];
        return validRoutes.some((route) => matchPath(route, location.pathname));
    }, [location]);

    return <GameMessage isColumnLayout={isColumnLayout} dynamicHeight={dynamicHeight} />;
};
